export const iconFontAwesomeMovingPeopleCarryBox = (
	<i className="fa-solid fa-people-carry-box"></i>
);
